export const banditAttack = new Image();
banditAttack.src = "assets/characterSprites/bandit/HeavyBandit.png";
banditAttack.width = 48;
banditAttack.height = 48;
banditAttack.yOffset = 95;
banditAttack.xOffset = 200;
banditAttack.cycleLoop = [0,1,2,3,4,5,6,7];